import React, { useContext, useEffect } from "react";
import { NetworkRedirectContainer } from "./NetworkRedirectStyled";
import { useParams, useNavigate } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { UserContext } from "../../context/userContext";
import { getAccessTokenTiktok, getMyFollowersNetworks, validateStateTiktok } from "../../api/networksApi";
import { useState } from "react";
import Spinner from "../../components/Spinner/Spinner";
import Alert from "../../components/Alert/Alert";
import Lottie from 'react-lottie';
import * as animationData from './tiktok-icon.json';

export default function TiktokRedirect() {

    const navigate = useNavigate();
    //let { code, scopes, state } = useParams();

    const { userType, userToken, id, setTiktokFollowers } = useContext(UserContext);

    //const [isLoading, setIsLoading] = useState(true);
    const [isStopped, setIsStopped] = useState(false);
    const [isPaused, setIsPaused] = useState(false);

    const valores = window.location.search;
    const urlParams = new URLSearchParams(valores);

    //Accedemos a los valores
    let code = urlParams.get('code');
    let scopes = urlParams.get('scopes');
    let state = urlParams.get('state');

    const [showAlertError, setShowAlertError] = useState(false);

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    useEffect(() => {

        if (userType !== '' && id !== null) {

            validateStateTiktok({ typeUser: userType, token: userToken, state }).then((response) => {

                if (response.message === true) {

                    getAccessTokenTiktok({ typeUser: userType, token: userToken, code }).then((response) => {

                        if (response.message === 'success') {
                            getMyFollowersNetworks({ userId: id, typeUser: userType }).then((response) => {

                                setTiktokFollowers(response[0].followers.tiktok)
                                //setIsLoading(false);
                                setIsStopped(true);
                                navigate('/myprofile');
                            })
                        } else {
                            //setIsLoading(false);
                            setIsStopped(true);
                            setShowAlertError(true);
                        }
                    })
                } else {
                    //setIsLoading(false);
                    setIsStopped(true);
                    setShowAlertError(true);
                }
            })
        }
    }, [state, userType, id])

    return (
        <NetworkRedirectContainer>

            <Lottie options={defaultOptions}
                height={200}
                width={200}
                isStopped={isStopped}
                isPaused={isPaused} />

            {/* <p>Redirect tiktok page</p>
            {(isLoading) && (<Spinner />)} */}

            {(showAlertError) && (<Alert
                title={<FormattedMessage id="alert_error_network_title" defaultMessage="Error" />}
                text={<FormattedMessage id="alert_error_tiktok_text" defaultMessage="No pudimos conectar su cuenta de tiktok, por favor intente mas tarde." />}
                setShowAlert={setShowAlertError}
                confirmText={<FormattedMessage id="alert_error_network_button" defaultMessage="Ir a mi perfil" />}
                onConfirm={() => { navigate('/myprofile') }}
            />)}

        </NetworkRedirectContainer>

    )
}